import { observer } from 'mobx-react';
import SpcViewModel from './SpcViewModel';
import { Appl } from '../../../../core/Appl';
import { Button, Input, InputCalendar, InputType } from '../../../../core/components/Index';

const RedepositForm = observer(() => {
  const vm = Appl.Services.get<SpcViewModel>('SpcViewModel');
  
  return (
    <>
    {!(vm.isAddingEstimate || vm.isEditingEstimate) && 
          <>
          <h1 className="w-full max-w-[860px] text-32px tracking-[-1%] text-[#363636] font-semibold mb-[0px]">Details Needed for Estimate — {vm.spcLovModel.serviceTypeListItems?.find(o=>o.id===vm.model?.spcTypeId)?.name}</h1>
          <p className="tracking--1percent">
          </p>
          <div className="text-[15px] leading-[175%] tracking-[-1.5%] mb-[16px]">
          <p className ="pt-3 pb-3">Provide the information below to calculate a preliminary estimate for redepositing contributions you previously withdrew from SCERS.</p>
          <ul className="marker:text-[10px] list-disc pl-5 pt-1">
                <li>You must enter the full amount of contributions withdrawn, including interest.</li>
                <li>The system will calculate interest automatically from the withdrawal date to the present.</li>
          </ul>
          </div>
          </>
      }
      {(vm.isAddingEstimate) && 
          <>
            <h1 className="w-full max-w-[830px] text-32px tracking-[-1%] text-[#363636] font-semibold mb-[16px]">Leave Period {vm.selectedEstimationIndex+1} Details — {vm.spcLovModel.serviceTypeListItems?.find(o=>o.id===vm.model?.spcTypeId)?.name}</h1>
            <p className="tracking--1percent">
            </p>
            <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[20px]">
              <p className ="pt-3 pb-3">Add the details for your additional withdrawal. Remember: you may enter up to five total withdrawals.</p>
            </div>
          </>
      }
      {(vm.isEditingEstimate) && 
          <>
            <h1 className="w-full max-w-[830px] text-32px tracking-[-1%] text-[#363636] font-semibold mb-[16px]">Leave Period {vm.selectedEstimationIndex+1} Details — {vm.spcLovModel.serviceTypeListItems?.find(o=>o.id===vm.model?.spcTypeId)?.name}</h1>
            <p className="tracking--1percent">
            </p>
            <div className="text-[15px] font-normal leading-[175%] tracking-[-1.5%] mb-[20px]">
              <p className ="pt-3 pb-3">Edit the details for this additional withdrawal. Remember: you may enter up to five total withdrawals.</p>
            </div>
          </>
      }
      <div className="max-w-6xl mx-auto">
          <h2 className="text-[22px] font-semibold text-[#363636] leading-[100%] tracking-[0px] mt-[32px] mb-[32px]"         >
            Your Information
          </h2>
          <div className="text-[15px] leading-[175%] tracking-[-1.5%] mb-[16px]">
            <p className="!mb-[0px] pt-3 font-bold">
              Withdrawal Date
            </p>
            <p className='text-[15px] !mt-[-8px] !mb-[-20px]'>
              Enter the date your contributions were withdrawn.
            </p>
          </div>
          <div className="grid grid-cols-1 gap-[20px] mb-[30px] !mt-[0px]">
            <div className="">
            <InputCalendar
                  id="withdrawDate"
                  value={vm.currentEstimationDetail?.withdrawDate!}
                  className='w-[50vw] md:w-[180px] h-[38px] !border !border-[#C5C5C5] !rounded !placeholder:text-orange-500'
                  label=" "
                  showHint={false}
                  onChange={(e) => {
                    vm.onInputChange(e, 'withdrawDate', vm.currentEstimationDetail);
                  }}
                  onBlur={async () => await vm.onEstimationDateChangeAsync()}
                  required={false}
                  placeholderText='mm/dd/yyyy'
                />
            </div>
          </div>
           <div className="text-[15px] leading-[175%] tracking-[-1.5%] mb-[16px]">
              <p className="pt-3 font-bold !mb-[-2px]">
                Amount Withdrawn
              </p>
              <p>
                Enter the total amount of contributions you withdrew, including interest.
              </p>
            </div>
            <div className="flex items-center gap-[20px] mb-[32px]">
              <div>
                <Input
                    id="withdrawAmount"
                    value={vm.currentEstimationDetail.withdrawAmount}
                    inputType={InputType.Number}
                    onChange={(e:any) => {
                      vm.currentEstimationDetail.withdrawAmount = e.originalEvent?.currentTarget?.value.replace(/,/g, '') ;
                    }}
                    prefix="$"
                    prefixPosition="left"
                    minFractionDigits={2}
                    formatNumbers={true}
                    numberAlignment="right"
                    placeholder="e.g. 12,000.00"
                  />
              </div>
              
            </div>
          </div>
          <div className="flex !mt-[48px] flex-wrap gap-2 sm:flex-nowrap">
          <Button
            title="Save & Continue"
            className='border border-[#34571933] !w-[161px]'
            rounded
            onClick={async () => {
              await vm.onEnterDetailsStepChangeAsync();
            }}
            disabled={
            vm.currentEstimationDetail?.withdrawDate === undefined
            || vm.currentEstimationDetail?.withdrawAmount === undefined
                    }
          />
          {(vm.isAddingEstimate || vm.isEditingEstimate) && <Button title="Cancel" severity='warning' outlined rounded onClick={async () => await vm.cancelAddEstimateAsync()} />}
        </div>
    </>
  );
});

export default RedepositForm;
